import projection from '../generated/pwj5m1f1.json'; import { AcceptanceManifest } from '../types';
export const pwj5m1f1AcceptanceManifest = projection as AcceptanceManifest;
